export { default, getServerSideProps } from '../../components/SearchPage'
